import api from '../api/client';

export const auditoriaService = {
  listar: (organizadorId, filtros = {}, page = 1, pageSize = 50) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('page_size', pageSize);
    if (filtros.usuario_id) params.append('usuario_id', filtros.usuario_id);
    if (filtros.entidade) params.append('entidade', filtros.entidade);
    if (filtros.acao) params.append('acao', filtros.acao);
    if (filtros.data_inicio) params.append('data_inicio', filtros.data_inicio);
    if (filtros.data_fim) params.append('data_fim', filtros.data_fim);
    return api.get(`/organizadores/${organizadorId}/auditoria?${params}`);
  },

  exportar: (organizadorId, filtros = {}, formato = 'csv') => {
    const params = new URLSearchParams();
    params.append('formato', formato);
    if (filtros.usuario_id) params.append('usuario_id', filtros.usuario_id);
    if (filtros.entidade) params.append('entidade', filtros.entidade);
    if (filtros.acao) params.append('acao', filtros.acao);
    if (filtros.data_inicio) params.append('data_inicio', filtros.data_inicio);
    if (filtros.data_fim) params.append('data_fim', filtros.data_fim);
    return api.get(`/organizadores/${organizadorId}/auditoria/exportar?${params}`, {
      responseType: 'blob',
    });
  },
};

